import { useNextPlan, usePlanStacks } from '@zapier/upsells/src/hooks';

import {
  Account,
  PlanType,
  TrialType,
  UpgradeReason,
} from '@zapier/upsells/src/types';

import { getNextPlanTypeForUpgradeReason } from '@zapier/upsells/src/utils';

type Props = {
  account: Account | undefined;
  activeTrialType: TrialType | undefined;
  upgradeReason: UpgradeReason;
};

export const usePlanForUpgradeReason = ({
  account,
  activeTrialType,
  upgradeReason,
}: Props) => {
  const {
    error: planStacksError,
    isLoading: isLoadingPlanStacks,
    planStacks,
  } = usePlanStacks();

  let planType: PlanType | undefined;

  if (account?.plan && planStacks && planStacks.length > 0) {
    planType = getNextPlanTypeForUpgradeReason({
      activeTrialType,
      currentPlan: account?.plan,
      planStacks,
      upgradeReason,
    });
  }

  const {
    error: nextPlanError,
    isLoading: isLoadingNextPlan,
    nextPlan: planForUpgradeReason,
  } = useNextPlan({
    accountId: account?.id,
    interval: account?.plan?.interval,
    skip: !account || !planType || isLoadingPlanStacks,
    type: planType,
  });

  const isLoading = !account || isLoadingNextPlan || isLoadingPlanStacks;

  return {
    error:
      (!planType && !isLoading) || nextPlanError || planStacksError
        ? 'An error has occurred. Please try again.'
        : undefined,
    isLoading,
    plan: planForUpgradeReason,
  };
};
